var map = {
	"./en-US.json": "yGDv",
	"./ms-MY.json": "uu5U",
	"./th-TH.json": "4EKW",
	"./vi-VN.json": "NPoV",
	"./zh-CN.json": "YAZq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sXxw";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales [A-z0-9-_,\s]+\.json/
// module id = sXxw
// module chunks = 90